import { Component, OnDestroy } from '@angular/core';
import { AmdocsEventBusService } from 'amdocs-core-package';
import { CONSTANTS } from 'src/app/constants';

@Component({
  selector: 'app-notification-toast',
  templateUrl: './notification-toast.component.html',
  styleUrls: ['./notification-toast.component.scss']
})
export class NotificationToastComponent implements OnDestroy {
  public hideNotification = true;
  public notificationMessage = '';
  private notificationTimeout: any;
  public notificationId: string = '';
  private showNotificationSubscription: any;
  private removeNotificationSubscription: any;
  constructor(private eventBus: AmdocsEventBusService) {
    this.showNotificationSubscription = this.eventBus.on('showNotification', (data) => {
      this.clearNotificationTimeout();
      this.notificationMessage = data? data.message : '';
      this.showNotificationMessage();
      this.notificationId = data? data.sys_id : '';
    }, true);
 
    this.removeNotificationSubscription = this.eventBus.on('removeNotification', (data) => {
      this.hideNotificationMessage(data);
    }, true);
  }
 
  showNotificationMessage() {
    this.hideNotification = false;
  }
 
  hideNotificationMessage(notificationId: string) {
    this.eventBus.emit('notificationRemoved', notificationId);
    this.hideNotification = true;
  }
 
  private clearNotificationTimeout(): void {
    if (this.notificationTimeout) {
      clearTimeout(this.notificationTimeout);
      this.notificationTimeout = null;
    }
  }
 
  ngOnDestroy(): void {
    this.clearNotificationTimeout();
    if (this.showNotificationSubscription) {
      this.showNotificationSubscription.unsubscribe();
    }
    if (this.removeNotificationSubscription) {
      this.removeNotificationSubscription.unsubscribe();
    }
  }
}
